(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4616],{

/***/ 71449:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SensorConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SensorConfig"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopThreshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"findStops"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"energyMeter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopRegisterThreshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopValueThreshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataMultiplier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validatedSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analogOffset"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analogInputRange"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sensorUnit"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"accumulatorConfig"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetsOnPowerOff"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rolloverValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rolloverThreshold"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"discreteConfig"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onStates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offStates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultState"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"validatedSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"publishRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sampleRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"triggerIndex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataAlarm"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"languageCode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"notificationFrequency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updateBuffer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"repeatNotification"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"chartTimeScale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chart"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataFilter"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":693}}');
    doc.loc.source = JSON.parse('{"body":"fragment SensorConfig on SensorConfig {\\n  type\\n  stopThreshold\\n  findStops\\n  energyMeter\\n  stopRegisterThreshold\\n  stopValueThreshold\\n  dataMultiplier\\n  validatedSpeed\\n  expectedSpeed\\n  analogOffset\\n  analogInputRange\\n  sensorUnit {\\n    unit\\n    label\\n  }\\n  accumulatorConfig {\\n    resetsOnPowerOff\\n    rolloverValue\\n    rolloverThreshold\\n  }\\n  discreteConfig {\\n    onStates\\n    offStates\\n    defaultState\\n  }\\n  validatedSpeed\\n  expectedSpeed\\n  publishRate\\n  sampleRate\\n  triggerIndex\\n  dataAlarm {\\n    subscribers {\\n      type\\n      value\\n      languageCode\\n    }\\n    notificationFrequency\\n    updateBuffer\\n    repeatNotification\\n  }\\n  chartTimeScale\\n  chart {\\n    scale\\n    dataFilter\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 16634:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StopCause"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StopCause"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"languageCode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requireInitials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requireComment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enableCountermeasure"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetSetup"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constantTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parameterTimes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parameter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unlessParameter"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":335}}');
    doc.loc.source = JSON.parse('{"body":"fragment StopCause on StopCause {\\n  _id\\n  id\\n  name\\n  description\\n  categoryName\\n  meta {\\n    name\\n    description\\n    languageCode\\n  }\\n  languageCode\\n  stopType\\n  requireInitials\\n  requireComment\\n  enableCountermeasure\\n  targetSetup {\\n    constantTime\\n    parameterTimes {\\n      parameter\\n      time\\n      unlessParameter\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 60840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28066);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14724);
/* harmony import */ var _mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61978);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99109);








var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_1__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "flex",
            alignItems: "center",
            padding: theme.spacing(2),
            backgroundColor: "#f7f7f7"
        },
        /* Styles applied to the action element. */ action: {
            flex: "0 0 auto",
            alignSelf: "center"
        },
        /* Styles applied to the content wrapper element. */ content: {
            flex: "1 1 auto"
        }
    };
});
var DialogHeader = function(_param) {
    var action = _param.action, title = _param.title, onClose = _param.onClose, _children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "action",
        "title",
        "onClose",
        "children"
    ]);
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                className: classes.content
            }, props), {
                children: title
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classes.action,
                children: [
                    action,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        id: "closeDialog",
                        onClick: onClose,
                        size: "large",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            fontSize: "small"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DialogHeader);


/***/ }),

/***/ 15608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ millisAsmmss; },
/* harmony export */   "HN": function() { return /* binding */ localDayWithTimezoneOffset; },
/* harmony export */   "KB": function() { return /* binding */ convertPcsPerTimeToWantedUnit; },
/* harmony export */   "MI": function() { return /* binding */ timeFormatVariable; },
/* harmony export */   "Ob": function() { return /* binding */ timeFormatyyyyMMMddhhmmsstimezone; },
/* harmony export */   "Ox": function() { return /* binding */ timeFormatdMMMMhmm; },
/* harmony export */   "Ud": function() { return /* binding */ guardedCallbackString; },
/* harmony export */   "_D": function() { return /* binding */ evaluateWeekSpan; },
/* harmony export */   "_t": function() { return /* binding */ isBrowserLocale24h; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "j0": function() { return /* binding */ toHHMMSS; },
/* harmony export */   "l8": function() { return /* binding */ DateTimeLabelFormatBasedOnBrowserLocale; },
/* harmony export */   "mc": function() { return /* binding */ xDateFormatBasedOnBrowserLocale; },
/* harmony export */   "rr": function() { return /* binding */ timeFormatyyyyMMdd; },
/* harmony export */   "tI": function() { return /* binding */ timeFormatdMMMMyyyyhhmm; },
/* harmony export */   "td": function() { return /* binding */ timeFormatyyyyMMdhmm; },
/* harmony export */   "vw": function() { return /* binding */ guardedCallback; },
/* harmony export */   "wQ": function() { return /* binding */ mod; },
/* harmony export */   "xQ": function() { return /* binding */ excelReadableDateFormat; },
/* harmony export */   "zs": function() { return /* binding */ timeFormatyyyyMMdhmmss; }
/* harmony export */ });
/* unused harmony exports guardedCallbackNumber, timeFormatyyyyMMMMdhmmss, isNewFeature */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88149);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99758);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31650);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30489);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22638);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25955);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52108);





// TODO: Drop the use of this function, it's too simple to keep :p Excel does
// the formatting for us.
var excelReadableDateFormat = function(date) {
    if (!date) {
        return "";
    }
    return new Date(date);
};
var localDayWithTimezoneOffset = function(date) {
    var localDay = new Date(date.getTime() - date.getTimezoneOffset() * 1..minutes);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(localDay.toISOString().split("T"), 1), calendarDay = ref[0];
    return calendarDay;
};
var guardedCallbackNumber = function(callback) {
    return function(param) {
        var value = param.target.value;
        var parsedValue = Number(value);
        if (Number.isNaN(parsedValue)) {
            return;
        }
        return callback(parsedValue);
    };
};
var guardedCallbackString = function(callback) {
    return function(param) {
        var value = param.target.value;
        if (typeof value !== "string") {
            return;
        }
        return callback(value);
    };
};
var guardedCallback = guardedCallbackString;
var mod = function(n, m) {
    return (n % m + m) % m;
};
/**
 * Time Formatting 7/3/2021 13:00 or 3/7/2021 1:00 PM
 * @param time
 */ var timeFormatyyyyMMdhmm = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
function millisAsmmss(ms) {
    var minutes = Math.floor(ms / (60 * 1000));
    var minutesms = ms % (60 * 1000);
    var sec = Math.floor(minutesms / 1000);
    return "".concat(minutes.toLocaleString(undefined, {
        minimumIntegerDigits: 2
    }), ":").concat(sec.toLocaleString(undefined, {
        minimumIntegerDigits: 2
    }));
}
/**
 * Time Formatting 7/3/2021 13:00:00 or 3/7/2021 1:00:00 PM
 * @param time
 */ var timeFormatyyyyMMdhmmss = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7. marts 13:00 or March 7, 1:00 PM
 * @param time
 */ var timeFormatdMMMMhmm = function(time, locale) {
    var genericTimeFormat = {
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7. marts 2021 13:00 or March 7, 2021, 1:00 PM
 * @param time
 */ var timeFormatdMMMMyyyyhhmm = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7/3/2021 or 3/7/2021
 * @param time
 */ var timeFormatyyyyMMdd = function(time, locale) {
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(time, Date) === false || isNaN(time.getTime())) {
        console.error("!Error: Parameter time was not an instane of date!");
        return "Invalid Date!";
    }
    var genericTimeFormat = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7/3/2021 13:00:00 or 3/7/2021 1:00:00 PM
 * @param time
 */ var timeFormatyyyyMMMMdhmmss = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "short",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    };
    return intlFormat(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting:
 * Wed, 7. Mar, 2021, 13:00:00 Central European Standard time
 * or
 * Wed, Mar 7, 2021, 1:00:00 PM Central European Standard time
 * @param time
 */ var timeFormatyyyyMMMddhhmmsstimezone = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "short",
        day: "2-digit",
        weekday: "short",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZoneName: "long"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
var isBrowserLocale24hCache = {};
/**
 * return true if locale in browser is 24h format
 */ var isBrowserLocale24h = function(language) {
    if (isBrowserLocale24hCache.hasOwnProperty(language)) {
        return isBrowserLocale24hCache[language];
    } else {
        var res = !new Intl.DateTimeFormat(language || navigator.language, {
            hour: "numeric"
        }).format(0).match(/AM|PM/);
        isBrowserLocale24hCache[language] = res;
        return res;
    }
};
/**
 * Time Formatting Monday, 15. Mar, 2021 - 13:00:00.000 or Monday, Mar 15, 2021 - 01:00:00.000 PM
 */ var xDateFormatBasedOnBrowserLocale = function(language) {
    if (isBrowserLocale24h(language)) {
        return "%A, %b %e, %Y - %H:%M:%S.%L";
    }
    return "%A, %e. %b, %Y - %I:%M:%S.%L%p";
};
/**
 * Time Formatting adds AM/PM formatting if browser locale is AM/PM
 */ var DateTimeLabelFormatBasedOnBrowserLocale = function(language) {
    var formats = {};
    if (isBrowserLocale24h(language)) {
        formats = {
            millisecond: "%H:%M:%S.%L",
            second: "%H:%M:%S",
            minute: "%H:%M",
            hour: "%H:%M",
            day: "%e. %b",
            week: "%e. %b",
            month: "%e. %b",
            year: "%b"
        };
    } else {
        formats = {
            millisecond: "%I:%M:%S.%L%p",
            second: "%I:%M:%S%p",
            minute: "%I:%M%p",
            hour: "%I:%M%p",
            day: "%b %e",
            week: "%b %e",
            month: "%b %e",
            year: "%b"
        };
    }
    return formats;
};
/**
 * Note: Format this way, instead of using date-fns, because date-fns format is timezone aware,
 * resulting in format(0, 'HH:mm:ss') = '01:00:00' for GMT+1.
 */ var toHHMMSS = function(v) {
    var secNum = Math.abs(Math.floor(v / 1000));
    var hours = Math.floor(secNum / 3600);
    var minutes = Math.floor((secNum - hours * 3600) / 60);
    var seconds = secNum - hours * 3600 - minutes * 60;
    hours = hours === 0 || isNaN(hours) ? "00" : (hours < 10 ? "0" : "") + "".concat(hours);
    minutes = minutes === 0 || isNaN(minutes) ? "00" : (minutes < 10 ? "0" : "") + "".concat(minutes);
    seconds = seconds === 0 || isNaN(seconds) ? "00" : (seconds < 10 ? "0" : "") + "".concat(seconds);
    var fs = hours + ":" + minutes + ":" + seconds;
    return v < 0 ? "-".concat(fs) : "".concat(fs);
};
/**
 * if i=14 it returns 14:00 or 2:00 PM depending on browser locale
 * @param i
 */ var timeFormatVariable = function(i, language) {
    if (isBrowserLocale24h(language)) {
        return i + ":00";
    } else {
        var timeString = "";
        if (i % 12 !== 0) {
            timeString = (i % 12).toString();
        } else {
            timeString = 12..toString();
        }
        if (i > 11) {
            timeString = timeString + ":00 PM";
        } else {
            timeString = timeString + ":00 AM";
        }
        return timeString;
    }
};
/**
 * turns number of pcs per time into wanted time unit (min/hour/day)
 */ var convertPcsPerTimeToWantedUnit = function(noOfPcs, currentUnit, wantedUnit) {
    var pcsPerMin = 0;
    //Convert pcs/currentUnit into pcs/min
    switch(currentUnit){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.DAY */ .cW.DAY:
            pcsPerMin = noOfPcs / 60 / 24;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.HOUR */ .cW.HOUR:
            pcsPerMin = noOfPcs / 60;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.MINUTE */ .cW.MINUTE:
            pcsPerMin = noOfPcs;
            break;
        default:
            _types__WEBPACK_IMPORTED_MODULE_4__/* .assertUnreachable */ .U(currentUnit);
            break;
    }
    //Convert pcs/min into pcs/wantedUnit
    var pcsPerWantedUnit = 0;
    switch(wantedUnit){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.DAY */ .cW.DAY:
            pcsPerWantedUnit = pcsPerMin * 60 * 24;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.HOUR */ .cW.HOUR:
            pcsPerWantedUnit = pcsPerMin * 60;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.MINUTE */ .cW.MINUTE:
            pcsPerWantedUnit = pcsPerMin;
            break;
        default:
            _types__WEBPACK_IMPORTED_MODULE_4__/* .assertUnreachable */ .U(wantedUnit);
            break;
    }
    return pcsPerWantedUnit;
};
var isNewFeature = function(releaseTime) {
    var age = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 7..days;
    return Date.now() <= new Date(releaseTime).getTime() + age;
};
function sleep(milliseconds) {
    return new Promise(function(r) {
        return setTimeout(r, milliseconds);
    });
}
var evaluateWeekSpan = function(date) {
    var dateCopy = new Date(date);
    dateCopy.setHours(0, 0, 0, 0);
    var monday = (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(dateCopy, 1);
    var mondayNextWeek = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(monday);
    return [
        monday,
        mondayNextWeek
    ];
};


/***/ })

}]);